'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002460 from "./presto.-Two-Factor-Auth-View$$anon$60.js";
import * as $j_presto$002etypes$0024 from "./presto.types$.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$0024 from "./presto.types$-Two-Factor-Auth$.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dId$0024 from "./presto.types$-Two-Factor-Auth-Id$.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dName$0024 from "./presto.types$-Two-Factor-Auth-Name$.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dPayload$0024 from "./presto.types$-Two-Factor-Auth-Payload$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$59() {
  this.bGg = null;
  this.bG8 = null;
  this.bG9 = false;
  this.bGh = null;
  this.bGi = false;
  this.bGl = null;
  this.bGe = null;
  this.bGf = false;
  this.bGa = null;
  this.bGb = false;
  this.bGc = null;
  this.bGd = false;
  this.bGj = false;
  this.bGk = false;
  this.bGg = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bGl = "TwoFactorAuth";
}
export { $c_Lpresto_TwoFactorAuthView$$anon$59 as $c_Lpresto_TwoFactorAuthView$$anon$59 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$59.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$59;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$59() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$59 as $h_Lpresto_TwoFactorAuthView$$anon$59 };
$h_Lpresto_TwoFactorAuthView$$anon$59.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.bGg;
});
$p.M = (function() {
  if ((!this.bG9)) {
    this.bG8 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bG9 = true;
  }
  return this.bG8;
});
$p.O = (function() {
  if ((!this.bGi)) {
    this.bGh = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bGi = true;
  }
  return this.bGh;
});
$p.D = (function() {
  return this.bGl;
});
$p.t = (function() {
  if ((!this.bGf)) {
    this.bGe = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("created", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("deleted", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("payload", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))));
    this.bGf = true;
  }
  return this.bGe;
});
$p.N = (function() {
  if ((!this.bGb)) {
    this.bGa = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dId$0024.$m_Lpresto_types$TwoFactorAuthId$().zs(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dName$0024.$m_Lpresto_types$TwoFactorAuthName$().zt(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024.$m_Lpresto_types$TwoFactorAuthType$().zv(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dPayload$0024.$m_Lpresto_types$TwoFactorAuthPayload$().zu(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))));
    this.bGb = true;
  }
  return this.bGa;
});
$p.Q = (function() {
  if ((!this.bGd)) {
    this.bGc = new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002460.$c_Lpresto_TwoFactorAuthView$$anon$60();
    this.bGd = true;
  }
  return this.bGc;
});
$p.v = (function() {
  if ((!this.bGk)) {
    this.bGj = false;
    this.bGk = true;
  }
  return this.bGj;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee591) => ((p) => \u03b4scrutinee591.zk(p)))($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$0024.$m_Lpresto_types$TwoFactorAuth$())));
});
var $d_Lpresto_TwoFactorAuthView$$anon$59 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$59, "presto.TwoFactorAuthView$$anon$59", ({
  T5: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$59 as $d_Lpresto_TwoFactorAuthView$$anon$59 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$59.js.map
